/**
 * 간단한 토큰 보관 + 인증 fetch 래퍼.
 * - setToken: 로그인/복원/갱신 시 현재 토큰 설정
 * - authFetch: Authorization 헤더 자동 부착, 401이면 등록된 핸들러(로그아웃) 호출
 */
let _token = null;
let _onUnauthorized = null;

export function setToken(t) {
  _token = t || null;
}
export function getToken() {
  return _token;
}
export function setUnauthorizedHandler(fn) {
  _onUnauthorized = fn;
}

export async function authFetch(url, opts = {}) {
  const headers = { ...(opts.headers || {}) };
  if (_token) headers.Authorization = `Bearer ${_token}`;
  const res = await fetch(url, { ...opts, headers });
  if (res.status === 401 && _onUnauthorized) {
    res.clone().json()
      .then((body) => _onUnauthorized(body?.message || null))
      .catch(() => _onUnauthorized(null));
  }
  return res;
}
